import { commandDevicesStatusMap, commandDevicesStatusTypes } from 'client/Commands/constants/CommandDevicesStatuses';
import { get } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import CommandQueueApi from 'client/api/v2/CommandQueueApi';
import CommandResultsApi from 'client/api/v2/CommandResultsApi';
import CommandsApi from 'client/api/v2/CommandsApi';
import SystemApi from 'client/api/v2/SystemApi';
import Vue from 'vue';

export const createCommandQueueCollection = () => {
  const collection = new CollectionModule(CommandQueueApi, 'id');
  const commandQueueCollectionModule = collection.extractModule();

  const {
    successful,
    failed,
    timeout,
    pending,
    running,
  } = commandDevicesStatusTypes;

  const getInitialState = () => {
    const { state } = commandQueueCollectionModule;
    state.features.isFetching = false;
    return {
      ...state,
    };
  };

  return {
    namespaced: true,

    state: getInitialState(),

    getInitialState,

    actions: {
      ...commandQueueCollectionModule.actions,

      async fetchAllCollectionCustom({ commit }, workflowInstanceId) {
        let commandQueues = await CommandQueueApi.fetchAll(null, null, [{
          name: 'workflow',
          operator: 'eq',
          value: workflowInstanceId,
        }]);

        const commandResultsResponse = await CommandResultsApi.search({
          filter: `workflowInstanceId:eq:${workflowInstanceId}`,
        });
        const commandResults = commandResultsResponse.data.results;

        commandQueues = [
          ...commandQueues,
          ...commandResults.map(commandR => ({
            command: commandR.workflowId,
            id: commandR._id,
            system: commandR.system,
            expiresAt: null,
          })),
        ];

        let systems = [];
        if (commandQueues.length > 0) {
          const systemResponse = await SystemApi.search({
            filter: {
              or: commandQueues.map(comandQ => ({ _id: comandQ.system })),
            },
          });
          systems = systemResponse.data.results;
        }

        const commandQueueMap = commandQueues.map(commandQ => {
          const commandResultFind = commandResults.find(
            commandR => commandR.system === commandQ.system,
          );

          const systemFind = systems.find(
            systemF => systemF._id === commandQ.system,
          );

          let status = pending;
          if (commandResultFind && commandResultFind.response) {
            switch (commandResultFind.response.data.exitCode) {
              case commandDevicesStatusMap[successful].exitCode:
                status = successful;
                break;
              case commandDevicesStatusMap[timeout].exitCode:
                status = timeout;
                break;
              default:
                status = failed;
                break;
            }
          } else if (commandResultFind && !commandResultFind.response) {
            status = running;
          }

          return {
            ...systemFind,
            serialNumber: systemFind.serialNumber ? systemFind.serialNumber : '',
            status,
            commandResult: commandResultFind,
            commandQueue: commandQ,
            workflowInstanceId,
          };
        });

        commit('SET_COLLECTION', {
          results: commandQueueMap,
          totalCount: commandQueueMap.length,
        });
      },

      async unbindSystem(context, commandQueueId) {
        return CommandsApi.cancelQueuedCommands([commandQueueId])
          .then((res) => get(res, 'data.count', 0));
      },

      setIsFetching({ commit }, isFetching) {
        commit('SET_IS_FETCHING', { isFetching });
      },
    },

    getters: {
      ...commandQueueCollectionModule.getters,

      getIsFetching(state = { features: { } }) {
        return state.features.isFetching;
      },
    },

    mutations: {
      ...commandQueueCollectionModule.mutations,

      SET_IS_FETCHING(state, { isFetching }) {
        Vue.set(state.features, 'isFetching', isFetching);
      },
    },
  };
};

export default createCommandQueueCollection();
